/**
 * 에피소드에 **사람이 적어 둔 기록**의 양(순수 파생).
 *
 * 목록 행은 판정 배지(성공·실패·결함·제외)와 밴드 칸으로 판정 결과를 표시한다. 그러나 판정 없이
 * 기록만 남긴 행은 표시가 없으면 빈 행과 구분되지 않는다. 리뷰어가 알고 싶은 것은
 * "누가 이 행을 봤고, 무엇을 적었나"다. 그래서 기록의 양을 한 수로 센다.
 *
 * **판정 배지가 이미 표시하는 축은 세지 않는다.** 결함·결과·제외는 각자 배지가 있다. 같은 사실을
 * 숫자로 다시 표시하면 두 표시가 무엇을 세는지 헷갈린다. 그래서 표기·코멘트 둘만 센다.
 *
 * **0 은 그리지 않는다.** 리뷰는 필수 절차가 아니다. "아직 안 봤음"을 세거나 색칠하면 필요 없는
 * 일을 재촉하게 된다. 기록이 있을 때만 그 양을 표시하고, 없으면 공간을 비운다.
 * 이것은 `episodeReviewState.ts` 의 배지 결정과 같은 원칙이다.
 */

import type { EpisodeSummary } from "@/api";

/** 축별 기록 수. `comment` 는 길이가 아니라 유무로 보므로 1 로 센다. */
export type EpisodeReviewRecord = {
  terms: number;
  comment: number;
  total: number;
};

export function episodeReviewRecord(episode: EpisodeSummary): EpisodeReviewRecord {
  const terms = episode.terms.length;
  // 공백만 있는 코멘트는 기록으로 보지 않는다. 서버는 앞뒤 공백을 제거하지만, 옛 행에는 공백이 남아 있다.
  const comment = (episode.review_comment ?? "").trim() === "" ? 0 : 1;
  return { terms, comment, total: terms + comment };
}

/** 배지 툴팁. 한 수로 합친 값을 축별로 나누어 보여 준다. 셀 것이 없으면 빈 문자열이다. */
export function episodeReviewRecordTip(record: EpisodeReviewRecord): string {
  const parts: string[] = [];
  if (record.terms > 0) {
    parts.push(`표기 ${record.terms}`);
  }
  if (record.comment > 0) {
    parts.push("코멘트 있음");
  }
  return parts.length === 0 ? "" : `리뷰 기록: ${parts.join(" · ")}`;
}
